import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    descriptionActive:
      'This is where you’ll find your authorized Direct Debits.',
    descriptionSuspended: 'You have no suspended Direct Debit.',
    titleActive: 'No active Direct Debit',
  },
  fr: {
    descriptionActive:
      'C’est ici que vous retrouverez tous vos prélèvements autorisés.',
    descriptionSuspended: 'Vous n’avez aucun prélèvement suspendu.',
    titleActive: 'Aucun prélèvement actif',
  },
});

export default locales;
